import { BlameLogType } from '@debbie/common/dist/blamelog/index.js';
import moment from 'moment';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import THEME from '../../../theme.js';
import ButtonDrop from '../../ButtonDrop.js';
import { Table } from '../../index.js';
import { Meta } from './style.js';
export const DocumentDetails = ({ blamelog }) => {
    const [open, setOpen] = useState(false);
    return (React.createElement(ButtonDrop, { open: open, onOpen: () => setOpen(true), onClose: () => setOpen(false), size: "mini", info: true, maxWidth: "500px", minWidth: "500px" },
        React.createElement(Meta, null,
            React.createElement(Table, { zebra: true },
                React.createElement(DocumentDetailsContent, { blamelog: blamelog })))));
};
const DocumentDetailsContent = ({ blamelog }) => {
    switch (blamelog.type) {
        case BlameLogType.DocumentUpload:
            return React.createElement(DocumentUploadContent, { blamelog: blamelog });
        case BlameLogType.DocumentDelete:
            return React.createElement(DocumentDeleteContent, { blamelog: blamelog });
        case BlameLogType.DocumentSigned:
            return React.createElement(DocumentSignedContent, { blamelog: blamelog });
        default:
            return null;
    }
};
const DocumentUploadContent = ({ blamelog, }) => {
    const lang = useSelector((s) => s.lang);
    const { details } = blamelog;
    return (React.createElement(React.Fragment, null,
        details.fileName && (React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.blameLogs.fileName)),
            React.createElement("td", null, details.fileName))),
        details.documentType && (React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.blameLogs.documentType)),
            React.createElement("td", null, lang.documentTypes?.[details.documentType] || details.documentType)))));
};
const DocumentDeleteContent = ({ blamelog, }) => {
    const lang = useSelector((s) => s.lang);
    const { details } = blamelog;
    return (React.createElement(React.Fragment, null,
        details.fileName && (React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.blameLogs.fileName)),
            React.createElement("td", null, details.fileName))),
        details.documentType && (React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.blameLogs.documentType)),
            React.createElement("td", null, lang.documentTypes?.[details.documentType] || details.documentType)))));
};
const DocumentSignedContent = ({ blamelog, }) => {
    const lang = useSelector((s) => s.lang);
    const { details } = blamelog;
    return (React.createElement(React.Fragment, null,
        details.signedAt && (React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.blameLogs.signedAt)),
            React.createElement("td", null, moment(details.signedAt).format(THEME.DATE_FORMAT_LONG)))),
        details.signedBy && (React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("b", null, lang.blameLogs.signedBy)),
            React.createElement("td", null, details.signedBy)))));
};
//# sourceMappingURL=DocumentDetails.js.map